<app-base-action-modal
  modalTitle="Review Account Values"
  i18n-modalTitle
  primaryLabel="Continue with Specified Values"
  i18n-primaryLabel
  secondaryLabel="Edit Values"
  i18n-secondaryLabel
  (primaryClicked)="continueWithSpecifiedValues()"
  (secondaryClicked)="editValues()"
  (closeClicked)="editValues()">
  <div class="d-flex flex-column" [style.gap.rem]="2">
    <div *ngFor="let jurisdiction of jurisdictions" class="d-flex flex-column gap-3">
      <div class="d-flex flex-column gap-2">
        <span class="label-md">{{ jurisdiction.jurisdictionName }}</span>
        <ng-container *ngIf="jurisdiction.type === 'over-max'">
          <div class="paragraph-lg secondary" i18n>
            The monthly payment amount that was entered will put the account's estimated annual total over the annual
            maximum. Once the limit is reached, payments will cease until the following calendar year.
          </div>
        </ng-container>
        <ng-container *ngIf="jurisdiction.type === 'under-min'">
          <div class="paragraph-lg secondary" i18n>
            The monthly payment amount that was entered will fall short of the annual minimum. If the annual minimum is
            not reached by year-end, the difference will be paid out to the member.
          </div>
        </ng-container>
      </div>
      <div class="d-flex flex-column gap-3">
        <ng-container *ngIf="jurisdiction.type === 'over-max'">
          <div class="info-card d-flex flex-column gap-2">
            <span class="label-md" i18n>Annual Maximum</span>
            <div *ngIf="jurisdiction.maximumRaised" class="d-flex gap-2 align-items-start">
              <img [src]="'assets/icons/primary/Circle Info.svg'" alt="" [style.width.rem]="1" [style.height.rem]="1" />
              <span class="paragraph-md secondary-text" i18n>
                Maximum raised to the minimum (spousal age minimum election).
              </span>
            </div>
            <span class="paragraph-lg">{{ jurisdiction.maxAnnualAmount | currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="jurisdiction.type === 'under-min'">
          <div class="info-card d-flex flex-column gap-2">
            <span class="label-md" i18n>Annual Minimum</span>
            <span class="paragraph-lg">{{ jurisdiction.minAnnualAmount | currency }}</span>
          </div>
        </ng-container>
        <div class="info-card d-flex flex-column gap-2">
          <span class="label-md" i18n>Monthly Payment Amount</span>
          <div class="d-flex gap-2 align-items-center paragraph-lg">
            <span>{{ jurisdiction.monthlyPaymentAmount | currency }}</span>
            <span class="secondary" i18n>({{ jurisdiction.estimatedAnnualTotal | currency }} /yr)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-base-action-modal>
